export enum SortOrderOptions {
  Asc = 'Asc',
  Desc = 'Desc',
}
